// * Price formatting
export const numberWithDots = x => {
    if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    return '';
};

export const getRandom = (max, min = 0) => Math.floor(Math.random() * max + min)
